import { debug } from '@opallabs/quanta'

export default class DummyClient<T> {
  retVal: T

  constructor(retVal: T) {
    this.retVal = retVal
  }

  mockMethod(op: string, ...args: unknown[]) {
    debug('Would call:', op.toUpperCase(), ...args)
    return this.retVal
  }

  get(...args: unknown[]) {
    return this.mockMethod('get', ...args)
  }

  post(...args: unknown[]) {
    return this.mockMethod('post', ...args)
  }

  put(...args: unknown[]) {
    return this.mockMethod('put', ...args)
  }

  patch(...args: unknown[]) {
    return this.mockMethod('patch', ...args)
  }

  del(...args: unknown[]) {
    return this.mockMethod('del', ...args)
  }

  delete(...args: unknown[]) {
    return this.mockMethod('delete', ...args)
  }
}
